var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({},_vm.$listeners),[_c('r-icon',{staticClass:"cursor-pointer",class:("text-" + _vm.color),attrs:{"name":"delete","size":"20px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }